var render = function (_h,_vm) {var _c=_vm._c;return _c('a',_vm._b({class:_vm.data.staticClass,style:(_vm.data.staticStyle),attrs:{"href":_vm.parent.$url(_vm.props.url),"title":_vm.props.title}},'a',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }